import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/logo-TIL.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = ["src"]

import { useAuth0 } from "@auth0/auth0-vue";
import { ref } from "vue";
import SearchInput from "@/components/search/SearchInput.vue";
import UserLink from "@/components/UserLink.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const menuSchema = ref([
  {
    label: "New post",
    icon: "pi pi-fw pi-link",
    to: "/post",
  },
  {
    label: "Bookmarks",
    icon: "pi pi-fw pi-bookmark",
    to: "/bookmarks",
  },
  {
    label: "Extension",
    icon: "pi pi-fw pi-external-link",
    url: "https://chrome.google.com/webstore/detail/til/beongpgiledmjeadadaeflfdgjobelmd?hl=fr&authuser=1",
    target: "_blank"
  },
]);

const { logout, user, isLoading } = useAuth0();

const onLogoutClick = () => {
  logout({ returnTo: window.location.origin });
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_MenuBar = _resolveComponent("MenuBar")!

  return (!_unref(isLoading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MenuBar, { model: menuSchema.value }, {
          start: _withCtx(() => [
            _createElementVNode("img", {
              alt: "logo",
              src: _imports_0,
              height: "40",
              class: "ml-2 mr-1 cursor-hover",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
            })
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(SearchInput),
              _createElementVNode("img", {
                src: _unref(user).picture,
                alt: "profile picture",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/user/${_unref(user).sub}`))),
                class: "h-3rem mr-2 round-borders cursor-hover"
              }, null, 8, _hoisted_3),
              _createVNode(UserLink, {
                username: _unref(user).nickname!,
                id: _unref(user).sub!,
                class: "mr-2"
              }, null, 8, ["username", "id"]),
              _createVNode(_component_Button, {
                label: "Log out",
                onClick: onLogoutClick
              })
            ])
          ]),
          _: 1
        }, 8, ["model"])
      ]))
    : _createCommentVNode("", true)
}
}

})